import { QueryClient } from '@tanstack/vue-query'

/**
 * The one QueryClient. Passed to Vue's VueQueryPlugin inside every island and to
 * React's <QueryClientProvider> at the root, so a Vue mutation's
 * invalidateQueries refetches React components and vice versa. The 1,697-line
 * cache layer and its 78 invalidation sites stay live and consistent for the
 * whole migration.
 *
 * vue-query's QueryClient extends query-core's; both packages are pinned to the
 * same version so one copy of query-core is installed (Task 2 proves it).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 3 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: 1,
    },
  },
})
